export default "__VITE_ASSET__C9kVy10c__"